import { Injectable } from '@angular/core';
import { Group } from '../core-data-model/Group.model';
import { Job } from '../core-data-model/Job.model';
import { Person } from '../core-data-model/Person.model';

// Note that this can't be part of Util because of cyclical dependencies

@Injectable({ providedIn: 'root' })
export class TypesUtility {
    // Next functions are here to make TypeScript happy and
    // serve as type guards
    isNumber(x: any): x is number {
        return typeof x === 'number';
    }

    isString(x: any): x is string {
        return typeof x === 'string';
    }

    isGroup(x: any): x is Group {
        return x instanceof Group;
    }
    isPerson(x: any): x is Person {
        return x instanceof Person;
    }
    isJob(x: any): x is Job {
        return x instanceof Job;
    }
}
